import { JobAd } from '__models__/job_ad';

export function getJobApplication(applications, jobAd: JobAd) {
  const application = applications?.find(app => app.jobId.toString() === jobAd.id.toString());

  return application;
}
